module.exports = __webpack_public_path__ + "static/selfie-f2f409ec542afb46a1c62e97fedd98e5.jpg";